/**
 * Component: Video
 * ------------------------------------------------------------------------------
 * Video play component and lazy loading
 *
 * @namespace video
 */

/**
 * Export a new video instance.
 * @param {object} config - Configuration.
 */
export default (config) => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    videoSection: [...document.querySelectorAll(config.videoSection)],
  }

  function setEventListeners() {
    nodeSelectors.videoSection.forEach((video) => {
      video.querySelector('[data-trigger="video"]').addEventListener('click', () => {
        const videoEl = video.querySelector(config.videoContainer)
        video.classList.add('video-playing')
        videoEl.play()
      }, false)
    })
  }

  function lazyLoad() {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'))

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (const source in video.target.children) {
              const videoSource = video.target.children[source]
              if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src
              }
            }

            video.target.load()
            video.target.classList.remove('lazy')
            lazyVideoObserver.unobserve(video.target)
          }
        })
      })

      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo)
      })
    }

  }

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners()
    lazyLoad()
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
